import { apiDelete, apiGet, apiPatch, apiPost } from 'api/service';

export function listWebAuthProfiles() {
  return apiGet('/api/web-auth-profiles/');
}

export function createWebAuthProfile(body) {
  return apiPost('/api/web-auth-profiles/', body);
}

export function updateWebAuthProfile(id, body) {
  return apiPatch(`/api/web-auth-profiles/${id}/`, body);
}

export function deleteWebAuthProfile(id) {
  return apiDelete(`/api/web-auth-profiles/${id}/`);
}

export function testWebAuthProfileConnection(id, body = {}) {
  return apiPost(`/api/web-auth-profiles/${id}/test_connection/`, body);
}
